<template>
  <!-- 已平衡价格 -->
 <div v-loading="balancedPriceLoading">
  <!-- 公式 -->
  <el-row type="flex" justify="center">
  <div class="formulaBox1">
      <div>TransferredPrice<span> <i>USD</i> </span> =</div>
      <div>
        <p> &#x2211; (coindays destroyed · <span> <i>price</i></span>)</p>
        <p> <span><i>days</i> </span> · supply</p>
      </div>
     </div>
    </el-row>
    <el-row type="flex" justify="center">
    <p style="font-weight:600;color:rgba(0,0,0,0.6);" class="formulaBox2"> BalancedPrice<i>USD</i>  = RealisedPrice<i>USD</i>&nbsp; 一 &nbsp;TransferredPrice<i>USD</i></p>
  </el-row>
    <!-- 对数线性显示切换 -->
    <!-- <el-row>
      <el-col>    
         <el-button @click="handelLineSwitch"
         style="margin-left:100px;height:35px;border-radius:6px;"
         >{{ $t(`home.switch`)
          }}<span class="according"> {{ $t(switch3) }}</span></el-button
        >
      </el-col>
    </el-row> -->
    <el-row>
      <el-col :span="24">      
        <div
          id="balancedPriceBox"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>
<!-- 
    <div class="formula">
      <p>{{  $t(`home.formula`) }}</p>
     <div class="formulaBox1">
      <div>TransferredPrice<span>USD</span> =</div>
      <div>
        <p> &#x2211; (coindays destroyed . <span>price</span>)</p>
        <p> <span>days</span>.supply</p>
      </div>
     </div>
      <p class="formulaBox2"> BalancedPrice<span>USD</span>  = RealisedPrice<span>USD</span>&nbsp; 一 &nbsp;TransferredPrice<span>USD</span></p>

    </div> -->
  </div>
</template>

<script>
import IndexJs from "./index"
export default {
  mixins:[IndexJs]
}
</script>

<style lang="scss" scoped>
.formula{
  width: 98.7%;
    padding: 10px 0px;
    margin-bottom: -30px;
    // height: 60px;
    background: #e5e5e5;
    color: rgba(0, 0, 0, 0.6);
    p{
      padding: 0px 10px;
      font-weight: 600;
      span{
        font-weight: 500;
        font-size: 12px;
      }
      
    }
}

  .formulaBox1{
    // outline: 1px solid red;
    display: flex;
    padding: 0px 10px;
    font-weight: 600;
    div{
      // outline: 1px solid red;
      color: rgba(0, 0, 0, 0.6);

    }
    div:nth-of-type(1){
      font-size: 18px;
      font-weight: 600;
      span{
        font-size: 12px;
        font-weight: normal;
        // outline: 1px solid red;
        

      }
    }
    div:nth-of-type(2){
      display: flex;
      flex-direction: column;
      p{
        margin: 0px;
        // outline: 1px solid red;
      }
      p:nth-of-type(1){
        border-bottom: 1px solid rgba(0, 0, 0, 0.6);
      }

      p:nth-of-type(2){
        padding-left: 90px;
      }
      span{
        font-size: 16px;
        font-weight: 500;
      }
    
    }
  }
  .formulaBox2{  i{
      font-size: 12px;
      font-weight: 500;
    }}
  
 
</style>